<template>
  <v-dialog v-model="getModalGerarNfce" persistent max-width="720px">
    <v-card outlined>
      <v-card-title>Gerar NFC-e</v-card-title>
      <v-form ref="form" class="px-5">
        <v-card-text>
          <Alert />
          <v-layout row wrap>
            <v-flex xs12 md12>
              <v-text-field
                v-model="getNfce.cpf_cnpj"
                label="CPF/CNPJ"
                outlined
                dense
                v-mask="['##.###.###/####-##', '###.###.###-##']"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md12>
              <v-text-field
                v-model="getNfce.cfop"
                label="CFOP"
                outlined
                dense
                :rules="rules.cfop"
                v-mask="'#.###'"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>
      <v-card-actions>
        <v-btn
          color="default"
          outlined
          dense
          @click="setModalGerarNfce(false)"
          :loading="$store.getters.getOverlay"
          >Voltar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          outlined
          dense
          @click="gerar"
          :loading="$store.getters.getOverlay"
          >Gerar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      rules: {
        cfop: [(v) => !!v || "Campo obrigatório."],
      },
    };
  },
  computed: {
    ...mapGetters(["getNfce", "getVenda", "getModalGerarNfce"]),
  },
  methods: {
    ...mapActions(["gerarNFCe", "setModalGerarNfce"]),
    gerar() {
      if (this.$refs.form.validate()) {
        this.getNfce.venda_id = this.getVenda.id;
        this.gerarNFCe(this.getNfce);
      }
    },
  },
};
</script>
